module.exports = __webpack_public_path__ + "media/images/brand/logo-02-4bde4ff27006f165262d7d5092c49631.png";